module.exports = __webpack_public_path__ + "static/antd-card-hoverable-6ede05a71c3f5ae77513bb17a810f330.gif";